/** @jsxImportSource @emotion/react */
import { Container, Link, Stack, Text } from "basis";
import { AccountInfo } from "library/hooks/types";
import { CreditCard } from "../CreditCard/CreditCard";
import { SvgInline } from "../SvgInline/SvgInline";
import { ScreenProps } from "./types";

export const FinalCancel = ({ state }: ScreenProps) => {
  const { cardName, cardEndsWith } = state.accountInfo as AccountInfo;
  return (
    <Stack gap="8">
      <Container bg="grey.t05" padding="4">
        <CreditCard cardName={cardName} cardEndsWith={cardEndsWith} />
      </Container>
      <SvgInline name="close-account" width="236" />
      <Text textStyle="heading5" textStyle-sm="heading4">
        You cancelled your credit limit increase application.
      </Text>
      <Text>
        You will be able to reapply for a credit limit increase 30 days from the
        date of cancellation.
      </Text>
      <Link
        appearance="primary-button"
        width="216"
        href="/manage-account"
        newTab={false}
      >
        Manage account
      </Link>
    </Stack>
  );
};
